<template>
  <div class="content">
    <div class="courselist_header">
      <div class="back_to_list">
        <a-icon class="ZHIHUISHU_QZMD" type="left" @click="$router.back()" />
        <span class="ZHIHUISHU_QZMD" @click="$router.back()" v-if="!isEditCourseName">{{ activeName }}</span>
        <a-input
          @keyup.enter.prevent.stop="editCourseName"
          :placeholder="activeName"
          v-model="activeName"
          v-if="isEditCourseName"
          :maxlength="20"
        />
        <a-icon
          style="font-size: 18px"
          type="edit"
          theme="filled"
          class="ZHIHUISHU_QZMD"
          @click="isEditCourseName = !isEditCourseName"
        />
      </div>
      <div>
        <a-popover title="" trigger="click" placement="bottomRight">
          <a-button icon="share-alt" type="default" style="margin-right: 30px">分享活动链接</a-button>
          <template slot="content">
            <div class="share-content">
              <div class="share-url">
                <span class="url">{{ activityUrl }}</span>
                <span class="btn-copy" @click="shareActivityLink">复制链接</span>
              </div>
              <div class="share-tip">通过“电脑网页”或“手机”打开该链接即可观摩课堂直播</div>
            </div>
          </template>
        </a-popover>
        <a-button icon="share-alt" type="default" class="ZHIHUISHU_QZMD" @click="getInvitationCode('')">
          分享活动参加码
        </a-button>
        <a-button
          type="primary"
          style="margin-left: 30px"
          class="ZHIHUISHU_QZMD link_active_btn"
          @click="handleActivityModal({ showModal: true, option: 'relateLive' })"
        >
          <a-icon type="plus-circle" theme="filled" />
          关联直播
        </a-button>
      </div>
    </div>
    <div class="count_box">
      <div>
        <div>
          活动周期：
          <span>{{ startTime }}</span>
        </div>
        <div>
          活动进度：
          <span>{{ progress }}</span>
        </div>
      </div>
      <div>一次活动对应一个活动参加码</div>
    </div>
    <div class="classroom-manage">
      <a-table
        :columns="columns"
        :data-source="liveList"
        :row-key="(record, index) => record.liveId"
        :pagination="false"
        :loading="tabLoading"
        :customRow="customRow"
      >
        <template slot="liveStatus" slot-scope="text, record">
          <a-tag :color="record.liveStatus | filterActiveListStatusTag">{{ text }}</a-tag>
        </template>
        <template slot="liveName" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="liveCode" slot-scope="text, record">
          <p :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</p>
          <p v-if="record.lcLiveId" :class="record.status == '2' ? 'end_gray' : ''">LC:{{ record.lcLiveId }}</p>
        </template>
        <template slot="isSafeguard" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="className" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="watchList" slot-scope="text, record">
          <div v-if="text.length">
            <span v-for="(item, index) in text" :key="item" :class="record.status == '2' ? 'end_gray' : ''">
              {{ item }}
              <span v-if="text.length > 1 && index != text.length - 1">;</span>
            </span>
          </div>
          <div v-if="text.length == 0">
            <span :class="record.status == '2' ? 'end_gray' : ''">--</span>
          </div>
        </template>
        <template slot="schoolNameAndClassName" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="teacherPhone" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="startTime" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="endTime" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="updateTime" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="action_box">
            <a-tooltip v-show="record.status == 2">
              <template slot="title">回放</template>
              <img
                @click.prevent.stop="backVideoPlay(record)"
                style="width: 20px; height: 20px; cursor: pointer; margin-right: 5px"
                src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202112/dc10ac55ef3d48ac807d0bc4a266c02c.png"
                alt=""
              />
            </a-tooltip>
            <a-tooltip>
              <template slot="title">分享</template>
              <img
                @click.prevent.stop="getInvitationCode(record, 1)"
                style="width: 20px; height: 20px; cursor: pointer; margin-right: 5px"
                src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202112/c054994da71046a19233444553407961.png"
                alt=""
              />
            </a-tooltip>
            <a-tooltip>
              <template slot="title">删除</template>
              <img
                @click.prevent.stop="showDeleteConfirm(record)"
                style="width: 20px; height: 20px; cursor: pointer; margin-right: 5px"
                src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202112/b2b0fcd1a994443dbb8f1a1c05a34b04.png"
                alt=""
              />
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>
    <!-- video: -->
    <drawer-for-vue-core-video-player
      @hideMaskForDrawer="hideMaskForDrawer"
      :drawerFlag="drawerFlag"
      :videoSrc="videoSrc"
      :videoSrcList="videoSrcList"
      @videoSrcChangeByChild="videoSrcChangeByChild"
    />
    <active-modal
      :activityModalData="activityModalData"
      :activityItem="curActivityItem"
      @refresh="getActiveDetail"
      @close="handleActivityModal({ showModal: false })"
    ></active-modal>
    <my-dialog @hideMask="dialogFlag = false" :dialogFlag="dialogFlag" width="400px" p_lr="0">
      <div class="dialog_inner_container">
        <div class="dialog_inner_container_header">分享活动参加码</div>
        <div class="dialog_inner_container_body">
          <div class="share_list">
            <div class="share_item" v-for="item in shareList" :key="item.title">
              <div class="share_item_top">
                <span class="share_item_top_title">{{ item.title }}：</span>
                <span class="share_item_top_body">{{ item.joinCode }}</span>
              </div>
              <div class="share_item_bottom">
                {{ item.explainText }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </my-dialog>
    <my-dialog @hideMask="dialogFlagForDelete = false" :dialogFlag="dialogFlagForDelete" width="330px" p_lr="0">
      <div class="dialog_inner_container_for_delete">
        <div class="dialog_inner_container_for_delete_header">提示</div>
        <div class="dialog_inner_container_for_delete_body">是否确认解除关联该直播</div>
        <div class="dialog_inner_container_for_delete_footer">
          <div
            :class="[
              'dialog_inner_container_for_delete_footer_inner_item',
              index === 1 ? 'm_l15' : '',
              'ZHIHUISHU_QZMD'
            ]"
            v-for="(item, index) in deleteOperationList"
            :key="item.title"
            :style="{
              backgroundColor: item.bgc,
              border: item.border,
              color: item.color
            }"
            @click="deleteOperationItemClick(item)"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="loading_mask" v-if="dialogLoadingForDelete">
          <a-spin />
        </div>
      </div>
    </my-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const columns = [
  {
    title: '状态',
    width: 120,
    dataIndex: 'liveStatus',
    scopedSlots: { customRender: 'liveStatus' }
  },
  {
    title: '直播名称',
    dataIndex: 'liveName',
    align: 'center',
    scopedSlots: { customRender: 'liveName' }
  },
  {
    title: 'ID',
    dataIndex: 'liveCode',
    scopedSlots: { customRender: 'liveCode' }
  },
  {
    title: '主讲学校-教室',
    align: 'center',
    dataIndex: 'schoolNameAndClassName',
    scopedSlots: { customRender: 'schoolNameAndClassName' }
  },
  {
    title: '开始时间',
    dataIndex: 'startTime',
    scopedSlots: { customRender: 'startTime' }
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    scopedSlots: { customRender: 'endTime' }
  },
  {
    title: '操作',
    width: 115,
    key: 'id',
    scopedSlots: { customRender: 'action' }
  }
]
export default {
  components: {
    'class-modal': () => import('../../components/classModal/index'),
    'active-modal': () => import('../../components/activeModal/index'),
    'my-dialog': () => import('../../components/my_dialog'),
    'my-drawer': () => import('../../components/my_drawer'),
    'drawer-for-vue-core-video-player': () =>
      import('../../components/componentsForPage/drawer_for_vue_core_video_player')
  },
  data() {
    return {
      activityDetail: {},
      columns,
      activeId: '',
      isEditCourseName: false,
      activeName: '',
      endTime: '',
      startTime: '',
      progress: '',
      liveList: [],
      tabLoading: false,
      customRow: (record, index) => ({
        on: {
          click: () => {
            // 单元行点击事件
            this.operationForGoSupervision(record)
          }
        }
      }),
      dialogFlag: false,
      shareList: [],
      shareList1: [
        {
          title: '活动参加码',
          joinCode: '- -',
          explainText: '在“知到”APP、同步课堂网登录页面输入该参加码，看活动直播、回放',
          show: true
        }
      ],
      shareList2: [
        {
          title: '老师参加码',
          joinCode: '- -',
          explainText: '老师参加码只能发送给主讲老师，泄漏后可能造成直播异常',
          show: true
        },
        {
          title: '听课教室参加码',
          joinCode: '- -',
          explainText: '听课/互动教室的助教，在“知到-教师版”APP输入该参加码，加入直播课堂',
          show: true
        },
        {
          title: '观摩旁听参加码',
          joinCode: '- -',
          explainText: '个体学生，在“知到”APP输入该参加码，看直播、回放',
          show: true
        }
      ],
      activityLiveVoList: [],
      dialogFlagForDelete: false,
      deleteData: {},
      dialogLoadingForDelete: false,
      deleteOperationList: [
        {
          title: '确定解除',
          bgc: '#FFF',
          border: '1px solid #D9D9D9',
          color: '#595959',
          type: 0
        },
        {
          title: '取消解除',
          bgc: '#5f60d3',
          border: 'none',
          color: '#FFF',
          type: 1
        }
      ],
      // showModal: false,
      schoolCode: '',
      videoSrcList: [],
      videoSrc: '',
      drawerFlag: false,
      activityModalData: {
        activityItem: {}
      },
      curActivityItem: {},
      activityUrl: ''
    }
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo'])
  },
  filters: {
    filterActiveListStatusTag(liveStatus) {
      let res = 'blue'
      switch (String(liveStatus)) {
        case '未开始':
          res = 'blue'
          break
        case '进行中':
          res = 'green'
          break
        case '已结束':
          res = 'orange'
          break
      }
      return res
    }
  },
  async mounted() {
    this.activeId = this.$route.query.id
    await this.getActiveDetail()
  },
  methods: {
    handleActivityModal(obj = {}) {
      const { liveList, activeId, activityDetail = {} } = this
      const { activityName, schoolCode, startTimeAndEndTime } = activityDetail
      const { showModal, option } = obj

      this.curActivityItem = {
        activityName,
        liveList: liveList,
        id: activeId,
        liveId: liveList.map((i) => i.liveId).join(','),
        schoolCode,
        activityType: 1,
        watchVideo: 1,
        endTime: (startTimeAndEndTime || '').split('~')[1],
        startTime: (startTimeAndEndTime || '').split('~')[0]
      }
      this.activityModalData = {
        showModal,
        option,
        isEdit: option === 'relateLive',
        modalTitle: '关联直播',
        activityItem: this.curActivityItem
      }
    },
    async editCourseName() {
      if (this.activeName.length > 20) {
        return this.$message.error('活动名称不得大于20个字')
      }
      if (this.activeName.trim().length == 0) {
        return this.$message.error('活动名称不可为空')
      }
      let res = await this.$http.updateActivityInfo({
        activityId: this.activeId,
        activityName: this.activeName
      })
      this.isEditCourseName = false
      if (res.rt.resultStatus == -1 || res.code != 200) {
        return this.$message.error(res.rt.resultMessage || '修改活动名失败！')
      }
      this.getActiveDetail()
    },
    async getActiveDetail() {
      let res = await this.$http.getActivityLive({
        activityId: this.activeId
      })
      if (res.code !== 200) {
        return this.$message.error(res.msg || '请求活动详情失败！')
      }
      this.activityDetail = res.rt || {}
      this.activityUrl = `https://zhs-livecourse.zhihuishu.com/teacher/activityList?activityInviteCode=${encodeURIComponent(
        this.activityDetail.encryptInviteCode || ''
      )}`
      this.progress = this.activityDetail.activityProgress
      this.startTime = this.activityDetail.startTimeAndEndTime
      this.activeName = this.activityDetail.activityName
      this.liveList = this.activityDetail.activityLiveVoList
      this.schoolCode = this.activityDetail.schoolCode
    },
    shareActivityLink() {
      const textarea = document.createElement('textarea')
      document.body.appendChild(textarea)
      textarea.value = this.activityUrl
      textarea.select()
      const copyFalse = document.execCommand('copy')
      this.$message.success('复制成功!')
      textarea.remove()
    },
    async getInvitationCode(record, status = 3) {
      let res = await this.$http.getInvitationCode({
        id: record.liveId || this.activeId,
        type: status
      })
      if (res.code !== 200) {
        return this.$message.error(res.msg || '获取邀请码失败！')
      }
      if (status == 3) {
        res.rt[this.activeId]?.forEach((item, index) => {
          ;(this.shareList1[index] || {}).joinCode = item.inviteCode ? item.inviteCode : '- -'
        })
        this.shareList = this.shareList1
      } else {
        res.rt[record.liveId || this.activeId]?.forEach((item, index) => {
          this.shareList2[index].joinCode = item.inviteCode ? item.inviteCode : '- -'
        })
        if (record.liveType == '3' || record.liveType == '5') {
          this.shareList2[0].show = true
        } else {
          this.shareList2[0].show = false
        }
        if (!record) {
          this.isClassShare = true
        } else {
          this.isClassShare = false
        }
        this.shareList = this.shareList2
      }
      this.dialogFlag = true
    },
    showDeleteConfirm(record) {
      this.dialogFlagForDelete = true
      this.deleteData = record
    },
    async getVideoUrl(videoID) {
      // 直接照搬以前的逻辑
      // 老接口：
      // let result = await this.$http.getVideoById({
      //     videoID
      // })
      // 新接口：
      let result = await this.$http.getVideoByIdNew({
        videoID
      })
      result = result.data
      if (result.errorCode !== 0) return this.$message.error(result.errorMsg)
      let videoObj = (result.result.lines || []).find((item) => item.lineUrl) || {}
      if (!videoObj) return this.$message.error('抱歉，暂无视频哦')
      let videoSrc = ''
      videoSrc = videoObj.lineUrl
      return videoSrc
    },
    // 获取视频：
    // backVideoPlay({ videoId } = record) {
    backVideoPlay(record) {
      this.operationForGoSupervision(record)
      // 以下是老逻辑：
      return
      if (!videoId) return this.$message.error('课程结束1小时后生成回放，请稍后重试！如有问题请联系智慧树运维客服！')
      if (!videoId.length)
        return this.$message.error('课程结束1小时后生成回放，请稍后重试！如有问题请联系智慧树运维客服！')
      this.$nextTick(async () => {
        let videoUrl = []
        if (typeof videoId == 'string') {
          videoUrl = videoId.split(',') || []
        } else {
          videoUrl = videoId
        }
        // this.videoSrc = await this.getVideoUrl(videoUrl)
        // this.drawerFlag = true
        this.videoSrcList = []
        // 首先获取到所有的视频，默认播放第一个：
        for (let i = 0, len = videoUrl.length; i < len; i++) {
          try {
            let videoSrc = await this.getVideoUrl(videoUrl[i])
            this.videoSrcList.push(videoSrc)
          } catch (err) {
            console.log(err, 'err')
          }
        }
        if (this.videoSrcList.length) {
          this.videoSrc = this.videoSrcList[0]
          this.drawerFlag = true
        }
      })
    },
    hideMaskForDrawer() {
      this.drawerFlag = false
    },
    async deleteOperationItemClick({ type }) {
      switch (type) {
        case 0:
          try {
            this.dialogLoadingForDelete = true
            let result = await this.$http.deleteActivityLive({
              activityId: this.activeId,
              liveId: this.deleteData.liveId
            })
            this.dialogLoadingForDelete = false
            if (result.code !== 200) return this.$message.error(result.msg)
            let { rt: resultReally } = result
            if (resultReally.resultStatus !== 1)
              return this.$message.error(resultReally.resultMessage ? resultReally.resultMessage : '删除失败')
            this.$message.success('删除成功')
            this.dialogFlagForDelete = false
            await this.getActiveDetail()
          } catch (err) {
            console.log(err)
          }
          break
        case 1:
          this.dialogFlagForDelete = false
          break
      }
    },
    videoSrcChangeByChild(videoSrc) {
      this.videoSrc = videoSrc
    },
    async operationForGoSupervision(item) {
      // 现采用新版本的逻辑：
      const { classroomCode, status: liveStatus, liveId = '', mscId } = item
      switch (liveStatus) {
        case 0:
        case 1:
          if (classroomCode) {
            this.$router.push({
              name: 'InspectionTourDetail',
              query: {
                liveId,
                classroomCode
              }
            })
          } else {
            window.open(`https://zhs-livecourse.zhihuishu.com/teacher/IndividualStudent?liveId=${liveId}`, '_blank')
          }
          break
        case 2:
          // this.backVideoPlay(videoId ? [videoId] : [])
          // this.backVideoPlay(videoId)
          const role = '0'
          // const href = `https://tju-livecourse.zhihuishu.com/primary/#/playback?mscId=${mscId}&id=${liveId}&role=${role}`
          const href = `https://zhs-livecourse.zhihuishu.com/primary/#/playback?mscId=${mscId}&id=${liveId}&role=${role}`
          window.open(href, '_blank')
          break
      }
      // 旧版本的逻辑全部暂时注释：
      // let { liveId, status, liveType, videoId, version } = item
      // if (status != 1 && status != 2)
      //   return this.$message.warning('直播不在进行中，暂不支持进入督学页面')
      // // if (status == 2) return await this.backVideoPlay({ videoId })
      // if (status == 2) {
      //   window.open(`https://tp.zhihuishu.com/#/playback?role=0&id=${liveId}`, '_blank')
      //   // window.open(`https://www.livecourse.com/playback?id=${liveId}`, '_blank')
      //   return
      // }
      // if (liveType == 2 || liveType == 4 || liveType == 5) {
      //   let { href } = this.$router.resolve({
      //     name: 'LCSupervisionCourse',
      //     query: { liveId: liveId, userId: this.userInfo.userId },
      //   })
      //   window.open(href, '_blank')
      // } else {
      //   switch (item.liveOrigin) {
      //     case 4:
      //     case 6:
      //       const { href: clientSupervisionCourseHref } = this.$router.resolve({
      //         name: version === 'v2' ? 'ClientMSC2SupervisionCourse' : 'ClientSupervisionCourse',
      //         query: { liveId, userId: this.userInfo.userId }
      //       });
      //       window.open(clientSupervisionCourseHref, '_blank');
      //       break
      //     default:
      //       const { href: supervisionCourseHref } = this.$router.resolve({name: 'SupervisionCourse', query: { liveId, userId: this.userInfo.userId}});
      //       window.open(supervisionCourseHref, '_blank');
      //       break
      //   }
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin dialogTitle($color) {
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-weight: bold;
  color: $color;
  font-size: 16px;
  border-radius: 10px 10px 0 0;
  padding: 0 30px;
  border-bottom: 1px solid #e7e7e7;
}
@mixin verticalAndCrosswiseCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes scaleCircle {
  from {
    transform: translate(-50%, -50%) scale(0);
  }
  to {
    transform: translate(-50%, -50%) scale(100);
  }
}
::v-deep {
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    border-bottom: 0;
  }
  .ant-table-thead > tr > th {
    background: #f6f6f6;
  }
  .ant-table-tbody {
    tr:nth-child(even) {
      background: #f4f7fa;
    }
    .ant-table-row {
      cursor: pointer;
    }
  }
  .action {
    text-align: center;
    .action-icon {
      cursor: pointer;
    }
  }
  .ant-table-pagination {
    float: none;
    text-align: center;
  }
}
.dialog_inner_container {
  .dialog_inner_container_header {
    @include dialogTitle(#222);
  }
  .dialog_inner_container_body {
    width: 100%;
    height: auto;
    padding: 20px 30px 10px;
    border-radius: 0 0 10px 10px;
    .share_list {
      .share_item {
        width: 100%;
        height: auto;
        padding-bottom: 10px;
        margin-bottom: 20px;
        text-align: left;
        .share_item_top {
          font-weight: bold;
          font-size: 14px;
          position: relative;
          padding-left: 10px;
          .share_item_top_body {
            color: #2090ff;
          }
          &::before {
            content: '';
            width: 3px;
            height: 16px;
            background-color: #5f60d3;
            border-radius: 2px;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        .share_item_bottom {
          font-size: 14px;
          color: #858492;
          margin-top: 6px;
        }
        &:nth-of-type(1) {
          .share_item_bottom {
            color: #fe7c14;
          }
        }
      }
    }
  }
}
.courselist_header {
  background-color: #fff;
  box-shadow: 0 0 10px #ddd;
  padding: 25px;
  display: flex;
  justify-content: space-between;
  .back_to_list {
    cursor: pointer;
    display: flex;
    align-items: center;
    > input:nth-child(2) {
      margin-left: 15px;
    }
    > span:nth-child(2) {
      margin-left: 15px;
      font-weight: bold;
    }
    > i:nth-child(3) {
      margin-left: 15px;
      :hover {
        color: skyblue;
      }
    }
  }
  .link_active_btn {
    background: #5f60d3;
    border: none;
  }
}
.end_gray {
  color: #bfbfbf;
}
.count_box {
  height: 60px;
  line-height: 60px;
  display: flex;
  justify-content: space-between;
  > div:first-child {
    margin-right: 15px;
    display: flex;
    > div:nth-child(2) {
      margin-left: 50px;
    }
    div {
      > span {
        color: #5f60d3;
        font-weight: bold;
      }
    }
  }
  > div:last-child {
    color: orange;
    padding-right: 30px;
  }
}
.classroom-manage {
  min-height: 996px;
  text-align: left;
  background: #fff;
  box-shadow: 0 0 10px #ddd;
  border-radius: 10px;
}
.dialog_inner_container_for_delete {
  .dialog_inner_container_for_delete_header {
    @include dialogTitle(#222);
  }
  .dialog_inner_container_for_delete_body {
    padding: 15px;
    text-align: center;
  }
  .dialog_inner_container_for_delete_footer {
    width: 100%;
    height: 70px;
    padding-bottom: 23px;
    @include verticalAndCrosswiseCenter();
    .dialog_inner_container_for_delete_footer_inner_item {
      width: 74px;
      height: 32px;
      @include verticalAndCrosswiseCenter();
      font-size: 12px;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
      box-shadow: 0 0 5px #f5f5f5;
      transition: all 0.5s;
      letter-spacing: 1px;
      &:nth-of-type(1) {
        &:hover {
          border: 1px solid #2090ff !important;
          color: #2090ff !important;
        }
      }
      &:nth-of-type(2) {
        &:hover {
          background-color: #48a2fc;
        }
      }
    }
  }
}

.btn-share {
  box-sizing: border-box;
  display: inline-block;
  color: #5f60d3;
  border: 1px solid #5f60d3;
  width: 112px;
  height: 38px;
  line-height: 38px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}

.share-content {
  padding: 16px;
  width: 360px;
  .share-url {
    font-size: 14px;
    height: 28px;
    line-height: 28px;
    display: flex;
    margin-bottom: 12px;
    .url {
      display: inline-block;
      border: 1px solid #dcdee0;
      width: calc(100% - 64px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-left: 5px;
    }
    .btn-copy {
      display: inline-block;
      font-size: 12px;
      background: #5f60d3;
      color: #fff;
      width: 64px;
      height: 28px;
      text-align: center;
      cursor: pointer;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  .share-tip {
    font-size: 12px;
    color: #9fa2b1;
  }
}
</style>
